import { ClerkOfflineError } from '@clerk/nextjs/errors';

/**
 * True when Clerk `getToken` failed because the client appears offline
 * (`clerk_offline` / {@link ClerkOfflineError}).
 *
 * Distinct from auth failures: the session may still be valid; FAPI was
 * unreachable after Clerk's short offline retry window (~15s). Expected
 * transient noise — not a refresh infrastructure bug that should page
 * Sentry (PORTAL-178).
 *
 * @see https://clerk.com/docs/guides/development/errors/frontend-api
 */
export function isClerkOfflineError(err: unknown): boolean {
  if (ClerkOfflineError.is(err)) return true;
  if (!err || typeof err !== 'object') return false;

  const { code, message } = err as {
    code?: unknown;
    message?: unknown;
  };

  if (code === 'clerk_offline') return true;

  return (
    typeof message === 'string' &&
    (/code=["']clerk_offline["']/i.test(message) ||
      /Network request failed while offline/i.test(message))
  );
}
